import { Box, Chip, Grid, Typography } from '@mui/material';
import { gridContainer, infoGridItem } from '../Styles/CustodianContactDetailsStyles';
import { labelText, labelTitle } from '../../../assets/styles/appStyles';
import { facilityType } from '../../../Models/custodian/custodian-details-viewmodel';
import FacilityDepartmentAndPhysiciansInfo from '../../AddLocation/Components/FacilityDepartmentAndPhysiciansInfo';
import Panel from '../../../components/UI/Panel';
import EntityDepartmentAndPhysiciansDetails from './entityDepartmentAndPhysiciansDetails';

export default function EntityFacilityDetails({
  formik,
  facilityDetails
}: {
  formik: any;
  facilityDetails: facilityType[]
}) {
  return (
    <Grid rowSpacing={3} container sx={gridContainer} spacing={2}>
      <Grid container item rowSpacing={3}>
        <Grid item xs={6} sx={infoGridItem}>
          <Typography align="left" sx={labelTitle} mb={'4px'}>
            Facility Type
          </Typography>
          <Grid container spacing={1} sx={{ mb: 2 }}>
            {facilityDetails?.map((p) => (
              <Grid item key={p.id}>
                <Chip sx={{ minWidth: 120, color: 'white' }} label={p.facilityTypeName} color="primary" variant="filled" />
              </Grid>
            ))}
          </Grid>
        </Grid>
        <Grid item xs={6} sx={infoGridItem}>
          <Typography sx={labelTitle}>Notes</Typography>
          <Box>
            <Typography sx={labelText}>{formik?.facilityTypeNotes ?? '-'}</Typography>
          </Box>
        </Grid>
        <Grid item xs={12} sx={infoGridItem}>
          {formik?.departmentAndPhysicians?.length != 0 &&
            <Panel headerText="Department/Physicians">
              <EntityDepartmentAndPhysiciansDetails departmentAndPhysicians={formik?.departmentAndPhysicians} />
            </Panel>
          }
        </Grid>
      </Grid>
    </Grid>
  );
}
